import { render, staticRenderFns } from "./OogNotice.vue?vue&type=template&id=61f46988&scoped=true"
import script from "./OogNotice.vue?vue&type=script&lang=js"
export * from "./OogNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f46988",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61f46988')) {
      api.createRecord('61f46988', component.options)
    } else {
      api.reload('61f46988', component.options)
    }
    module.hot.accept("./OogNotice.vue?vue&type=template&id=61f46988&scoped=true", function () {
      api.rerender('61f46988', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/schedule/popup/OogNotice.vue"
export default component.exports